import { sendRequest } from '@/common/request-esc/request';

// @ts-ignore
const API_BASE_URL = `${import.meta.env.VITE_SAFE_HOST}/api`;

export const refreshUserCookies = (Q: string, T: string, pin: string, token: string) => {
  return sendRequest({
    url: `${API_BASE_URL}/user/refresh`,
    method: 'POST',
    params: {Q, T}
  }, token, pin);
};
